export type ModelConfig = {
  id: string;
  label: string;
  animal?: string;
  category?: string;
  workflow: string;
};

export const MODEL_CONFIGS: { [key: string]: ModelConfig } = {
  "fal-ai/flux-pro/v1.1-ultra": {
    id: "fal-ai/flux-pro/v1.1-ultra",
    label: "Dragon",
    category: "Elite",
    workflow: "comfy/MemeticaAI/lightningupscale",
  },
  "fal-ai/flux/dev": {
    id: "fal-ai/flux/dev",
    label: "Lion",
    category: "Core",
    workflow: "comfy/MemeticaAI/lightningupscale",
  },
  "fal-ai/imagen3": {
    id: "fal-ai/imagen3",
    label: "Rex",
    category: "Professional",
    workflow: "comfy/MemeticaAI/lightningupscale",
  },
  "fal-ai/imagen3/fast": {
    id: "fal-ai/imagen3/fast",
    label: "Hawk",
    category: "Speed",
    workflow: "comfy/MemeticaAI/lightningupscale",
  },
  "fal-ai/ideogram/v2": {
    id: "fal-ai/ideogram/v2",
    label: "Platypus",
    category: "Labs",
    workflow: "comfy/MemeticaAI/lightningupscale",
  },
  "fal-ai/recraft-v3": {
    id: "fal-ai/recraft-v3",
    label: "Phoenix",
    category: "New Release",
    workflow: "comfy/MemeticaAI/lightningupscale",
  },
};

export const getModelLabel = (modelId: string): string => {
  return MODEL_CONFIGS[modelId]?.label || "Select a model";
};
